/**
 * Welle 12 (pre139): Gemeinsame Button-Optik für die Steuerleiste.
 * Aus Companion.tsx extrahiert, damit CallControlBar und die übrigen
 * Companion-Buttons (Signatur/Chat) dieselbe Optik teilen.
 */
import type React from 'react';

export type BarBtnKind = 'normal' | 'danger' | 'accent' | 'hangup';

export function barBtn(kind: BarBtnKind): React.CSSProperties {
  const base: React.CSSProperties = { padding: '10px 16px', borderRadius: 10, fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer', border: 'none', minWidth: 96 };
  if (kind === 'danger' || kind === 'hangup') return { ...base, background: '#dc2626', color: '#fff' };
  if (kind === 'accent') return { ...base, background: 'var(--tenant-accent, #7c3aed)', color: '#fff' };
  return { ...base, background: 'var(--bg-elev-3, #2a2a2a)', color: 'var(--fg, #eee)', border: '1px solid var(--hairline)' };
}
